//CustomCalcBuilder.tsx

import BuilderComponentsPanel from "./BuilderComponentsPanel";
import BuilderPropertiesPanel from "./BuilderPropertiesPanel";
import CalculatorSurface from "./CalculatorSurface";
import EmbeddedCalculatorPreview from "./EmbeddedCalculatorPreview";
import ToolWindowFrame from "@/components/tools/ToolWindowFrame";

function BuilderCanvas() {
  return (
    <div className="h-full w-full overflow-hidden p-4">
      <div className="h-full w-full max-w-[1400px] mx-auto">
        <div className="h-full flex flex-col">
          <ToolWindowFrame title="Custom Calculator">
            <div className="h-full min-h-0 flex flex-col">
              {/* canvas area fills the remaining height inside ToolWindowFrame */}
              <div
                className="
                  flex-1 min-h-0
                  relative
                  rounded-lg
                  border border-white/10
                  bg-black/30
                  overflow-auto
                "
              >
                <CalculatorSurface />
              </div>
            </div>
          </ToolWindowFrame>
        </div>
      </div>
    </div>
  );
}

export default function CustomCalculatorBuilder() {
  return (
    <div
      className="h-full w-full flex overflow-hidden"
      onPointerDown={(e) => e.stopPropagation()}
    >
      {/* Left: Toolbox */}
      <div
        className="
          flex-shrink-0
          min-w-[180px]
          max-w-[240px]
          w-[20%]
          border-r border-white/10
          bg-black/30 backdrop-blur
        "
      >
        <BuilderComponentsPanel />
      </div>

      {/* Center: Canvas */}
      <div className="flex-1 min-w-0 bg-black/10">
        <BuilderCanvas />
      </div>

      {/* Right: Properties */}
      <div
        className="
          flex-shrink-0
          min-w-[220px]
          max-w-[300px]
          w-[22%]
          border-l border-white/10
          bg-black/30 backdrop-blur
        "
      >
        <BuilderPropertiesPanel />
      </div>
    </div>
  );
}

